// 项目相关的配置信息


module.exports = {
  // 打包输出的目录
  publicPath: process.env.NODE_ENV === 'development' ? '/' : '/node/2021pieces/'
}